<template>
  <a-modal
    destroyOnClose
    :maskClosable="false"
    :footer="null"
    centered
    :title="$t('title.inventoryLock')"
    v-model="visible"
    :confirm-loading="loading"
    width="60%">
    <a-space>
      <a-button @click="confirm" type="primary">{{ $t('button.confirm') }}</a-button>&nbsp;
      <a-button @click="cancel" type="primary">{{ $t('button.cancel') }}</a-button>&nbsp;
      <a-button @click="reset" type="primary">{{ $t('button.reset') }}</a-button>&nbsp;
    </a-space>
    <a-divider />
    <a-form-model :model="result" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('business.label.availableLockedQuantity')">
        <a-input-number v-model="result.availableLockingQuantity" style="width: 100%" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item :label="$t('business.label.lockedQuantity')">
        <a-input-number v-model="result.lockedQuantity" :max="result.availableLockingQuantity" :min="1" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item :label="$t('business.label.lockReasons')">
        <a-textarea
          v-model="result.reasons"
          :placeholder="$t('placeholder.pleaseEnterReason')"
          :auto-size="{ minRows: 10, maxRows: 20 }"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
  import { post } from '@/api/Api'
  import Api from '@/api'
  import { message } from 'ant-design-vue'

  export default {
    name: 'InventoryLockConfirmModal',
    data() {
      return {
        visible: false,
        value: '',
        record: undefined,
        result: {
          reasons: null,
          lockedQuantity: null,
          availableLockingQuantity: null
        },
        bak: {
          reasons: null,
          lockedQuantity: null,
          availableLockingQuantity: null
        },
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
        loading: false
      }
    },
    methods: {
      open(record) {
        this.record = record
        this.result.lockedQuantity = record.inventory.availableOutboundQuantity
        this.result.availableLockingQuantity = record.inventory.availableOutboundQuantity
        Object.assign(this.bak, this.result)
        this.visible = true
      },
      confirm() {
        this.loading = true
        let args = { inventory: { id: this.record.inventory.id, availableOutboundQuantity: this.result.lockedQuantity }, reasons: this.result.reasons, 'log.id': null, locking: true }
        post(Api.save, { type: 'inventoryLogPersister' }, args).then(res => {
          if (res.success) {
            message.success('锁定成功')
            this.$emit('success')
            this.visible = false
          }
        }).finally(() => {
          this.loading = false
        })
      },
      cancel() {
        this.visible = false
      },
      reset() {
        Object.assign(this.result, this.bak)
      }
    }
  }
</script>
